
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class OrderProcessingDialog extends Serenity.EntityDialog<OrderProcessingRow, any> {
        protected getFormKey() { return OrderProcessingForm.formKey; }
        protected getIdProperty() { return OrderProcessingRow.idProperty; }
        protected getLocalTextPrefix() { return OrderProcessingRow.localTextPrefix; }
        protected getNameProperty() { return OrderProcessingRow.nameProperty; }
        protected getService() { return OrderProcessingService.baseUrl; }
        protected getDeletePermission() { return OrderProcessingRow.deletePermission; }
        protected getInsertPermission() { return OrderProcessingRow.insertPermission; }
        protected getUpdatePermission() { return OrderProcessingRow.updatePermission; }

        protected form = new OrderProcessingForm(this.idPrefix);

    }
}